import ComboboxSetter from "Views/Components/Combobox/ComboboxSetter"
import { ComboboxOption } from "Views/Components/Combobox/Combobox";
import { AbrOrAsicSearchResponse } from "../../JurisdictionBusinessEntitySearchBox/AustralianEntitySearchBox";

type Props = {
	customerEntityDetails: AbrOrAsicSearchResponse[];
	value: AbrOrAsicSearchResponse | undefined;
	setValue: (data: AbrOrAsicSearchResponse) => void;
}

export const ChooseCustomerReportEntity: React.FunctionComponent<Props> = ({
	customerEntityDetails,
	value,
	setValue,
}) => {
	const getAvailableOptions = (): ComboboxOption<string>[] => {
		return customerEntityDetails.map(detail => ({
			value: detail.identifierNumber,
			display: `${detail.entityName} (${detail.lookUpMethod}-${detail.identifierNumber})`
		}))
	}
	return (
		<ComboboxSetter
			label="Choose Report Request Entity"
			value={value?.identifierNumber}
			setValue={newValue => {
				const selected = customerEntityDetails.find(detail => detail.identifierNumber === newValue);
				if (selected) {
					setValue(selected);
				}
			}}
			getOptionValue={item => item}
			options={getAvailableOptions()}
		/>
	)
}